/* eslint-disable react/no-danger */
import React from 'react';
import DayJS from 'react-dayjs';
import PropTypes from 'prop-types';
import CommunityLogoWithLink from '../Community/CommunityLogoWithLink';
import CommunityContact from '../Community/CommunityContact';

import './PibPageHeader.scss';

const PibPageHeader = ({
  residentCommunityData,
}) => {
  const {
    community,
    names,
    createdDate,
    changedDate,
    message,
  } = residentCommunityData || {};
  const { greeting } = community || {};

  return (
    <div className="pibPageHeader">
      <div className="pibPage-branding">
        <CommunityLogoWithLink
          className="pibPage-branding__logoLink"
          communityData={community}
        />
      </div>

      <div className="pibPage-welcome">
        <div className="pibPage-welcome__intro">
          {names && (
            <>
              {`${names}, ` || ''}
              {greeting || 'Your Personalized Interactive Brochure Is Ready.'}
            </>
          )}
        </div>

        <CommunityContact
          className="pibPage-welcome__contact"
          residentCommunityData={residentCommunityData}
        />

        <div className="pibPage-welcome__date">
          {createdDate && changedDate && (
            <>
              Personalized
              {' '}
              <DayJS element="span" format="MMMM D[,] YYYY">{createdDate}</DayJS>
              {' '}
              — Last edited
              {' '}
              <DayJS element="span" format="MMMM D[,] YYYY">{changedDate}</DayJS>
            </>
          )}
        </div>
      </div>

      {message && (
        <div className="pibPage-message">
          <div className="pibPage-message__body">
            <div dangerouslySetInnerHTML={{ __html: message }} />
          </div>
        </div>
      )}
    </div>
  );
};

PibPageHeader.propTypes = {
  residentCommunityData: PropTypes.shape({
    community: PropTypes.shape({
      name: PropTypes.string,
      greeting: PropTypes.string,
    }),
    salesCounselor: PropTypes.shape({}),
    names: PropTypes.string,
    createdDate: PropTypes.string,
    changedDate: PropTypes.string,
    message: PropTypes.string,
  }),
};

PibPageHeader.defaultProps = {
  residentCommunityData: null,
};

export default PibPageHeader;
